import { render } from "./upload-auto.vue?vue&type=template&id=4ef28622"
import script from "./upload-auto.vue?vue&type=script&lang=js"
export * from "./upload-auto.vue?vue&type=script&lang=js"

import "./upload-auto.vue?vue&type=style&index=0&id=4ef28622&lang=less"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__